import cn from 'classnames';
import { ElementType, ReactNode } from 'react';

import Text from 'components/BaseHelpers/Text';

import styles from './InlineIconText.module.scss';

export type InlineIconTextProps = {
  className?: string;
  field: string;
  icon: ReactNode;
  iconClassName?: string;
  tag?: ElementType;
};

const splitLastWord = (field: string) => {
  const fieldWithoutTrailingSpace = field.replace(/\s+$/, '');
  const match = fieldWithoutTrailingSpace.match(/^(.*\s)(\S+)$/s);

  return {
    leadingText: match?.[1] ?? '',
    lastWord: match?.[2] ?? fieldWithoutTrailingSpace,
  };
};

const InlineIconText = (props: InlineIconTextProps): JSX.Element => {
  const { className, field, icon, iconClassName, tag = 'span' } = props;
  const Tag = tag;
  const { leadingText, lastWord } = splitLastWord(field);

  return (
    <Tag className={cn(styles.main, className)}>
      {leadingText && <Text field={leadingText} />}
      <span className={styles.tail}>
        <Text field={lastWord} />
        <span className={cn(styles.icon, iconClassName)} aria-hidden="true">
          {icon}
        </span>
      </span>
    </Tag>
  );
};

export default InlineIconText;
